import React, { forwardRef } from "react";
import {
  Input
} from "./style"

const SilverInput = (props, ref) => {
  return <Input {...props} ref={ref} />
}

export default forwardRef(SilverInput);